import { IonCard, IonCardContent, IonRow } from '@ionic/react';
import { DqText } from '../../components/dq-text';
import React, { FC } from 'react';
import { JobReportGuestAuthMessages } from '../../intl/JobReportGuestAuthMessages';
import { useIntl } from 'react-intl';

/**
 * Displayed if email address is missing from share link.
 *
 * @constructor
 */
export const EmailAddressMissingCard: FC = () => {
  const { formatMessage } = useIntl();

  return (
    <IonCard className="content-card">
      <IonCardContent>
        <IonRow>
          <DqText variant="h3" color="dark">
            {formatMessage(JobReportGuestAuthMessages.emailAddressMissingTitle)}
          </DqText>
        </IonRow>
        <IonRow>
          <DqText className="ion-margin-vertical" variant="body" color="dark">
            {formatMessage(JobReportGuestAuthMessages.emailAddressMissingMessage)}
          </DqText>
        </IonRow>
      </IonCardContent>
    </IonCard>
  );
};
